export default __webpack_public_path__ + "static/nureinberg_3-2-db8b02902b2da0ba26f0b3d29e709318.jpg";